import React from 'react';
import styled from '@emotion/styled';

export const StepWrapper = styled.div`
  max-width: 23.125rem;
  width: 100%;

  p {
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
    color: #333333;
  }
`;

export const Header = styled.h3`
  font-family: 'OCRoboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding-top: 1rem;
  text-transform: none;
`;

export const BackWrapper = styled.div`
  align-items: center;
  cursor: pointer;
  color: #333333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 2rem;
  width: 100%;

  h3 {
    font-weight: 700;
    font-size: 16px;
    color: #000;
    text-transform: uppercase;
    font-family: 'OCRoboto';
  }
`;

export const BackText = styled.p`
  margin-top: .5rem;
  padding-bottom: 1.5rem;
  text-align: center;
  font-size: 12px;
`;

export const SplitInputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 1rem;

  > div {
    width: 48%;
  }
`;

export const InputWrapper = styled.div`
  width: 100%;
  padding: 0.5em 0;
`;

